import { Link } from "react-router-dom";
import React from "react";

interface CardProps {
  image?: string;
  title: string;
  type?: string;
  link: string;
  children?: React.ReactNode;
}

const BrokenImage = "/dhi.png";

const Card: React.FC<CardProps> = ({ image, title, type, link, children }) => {
  const imageOnError = (event: React.SyntheticEvent<HTMLImageElement>) => {
    event.currentTarget.src = BrokenImage;
    event.currentTarget.className =
      "object-cover w-full h-48 rounded-t-lg bg-gray-100 dark:bg-gray-800";
  };

  return (
    <div className="max-w-md w-full mx-auto rounded-xl shadow-lg overflow-hidden transition-transform duration-300 hover:scale-105 group">
      {/* Image on top */}
      <div className="w-full aspect-[16/9] overflow-hidden">
        <img
          src={image ? image : BrokenImage}
          onError={imageOnError}
          alt={title || "News Thumbnail"}
          className="object-cover w-full h-full transition-transform duration-300 group-hover:scale-105"
        />
      </div>
      {/* Card Content */}
      <div className="p-4 flex flex-col gap-2">
        {type && (
          <span className="text-xs font-semibold text-blue-600 dark:text-blue-300 uppercase tracking-wide">
            {type}
          </span>
        )}
        <h3 className="text-lg font-bold mb-1 line-clamp-2">
          <Link to={link} className="hover:underline">
            {title}
          </Link>
        </h3>
        {children}
      </div>
    </div>
  );
};

export default Card;
